import { Component, input, output } from '@angular/core';

import { OrderEntry } from '@boels/models';
import { TranslocoModule } from '@jsverse/transloco';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'boels-order-entry-delete',
  imports: [TranslocoModule, FaIconComponent, NgbTooltip],
  templateUrl: './order-entry-delete.component.html',
  styleUrl: './order-entry-delete.component.scss',
})
export class OrderEntryDeleteComponent {
  orderEntry = input.required<OrderEntry>();
  disabled = input<boolean>();
  deleteOrderEntry = output<number>();

  remove() {
    const { entryNumber } = this.orderEntry();
    if (entryNumber !== undefined) {
      this.deleteOrderEntry.emit(entryNumber);
    }
  }

  protected readonly trashIcon = faTrashAlt;
}
